module.exports = __webpack_public_path__ + "img/LogoDashboard-13.7a135066.svg";